// plugins/00.auth-init.ts
import { useAuthStore } from '~/store/auth'

export default defineNuxtPlugin(() => {
	const config = useRuntimeConfig()
	const auth = useAuthStore()
	const token = useCookie<string | null>(config.public.auth.name_cookie)

	// 1) hidratar token
	if (token.value && auth.token !== token.value) {
		auth.ADD_TOKEN(token.value)
	}

	// No bloquees la hidratacion inicial de la app esperando /me.
	if (token.value && !auth.user && !auth.isFetchingMe) {
		auth.isFetchingMe = true
		void auth.fetchMe().finally(() => {
			auth.isFetchingMe = false
		})
	}
})
